import { Stack } from "@mui/system";

import React from "react";

import { Button, Typography, useTheme } from "@mui/material";

interface RoundedButtonProps {
  title: string;
  onClose: () => void;
}

/**
 * Purpose of this button is to centralize the button styling for drawer close (and other rounded buttons) button
 * used across the customer facing app.  Its different to the StyledButton in design.
 */
export const RoundedButton = ({ title, onClose }: RoundedButtonProps) => {
  const {
    palette: { oscar },
  } = useTheme();
  return (
    <Stack display="flex" justifyContent="center" width="100%">
      <Button
        sx={({ palette }) => ({
          alignSelf: "center",
          borderColor: palette.oscar.light.content.link,
          borderStyle: "solid",
          borderWidth: 2,
        })}
        onClick={onClose}
      >
        <Typography color={oscar.light.content.link} variant="buttonS">
          {title}
        </Typography>
      </Button>
    </Stack>
  );
};
